import React from "react";

import { faCloudArrowUp } from "@fortawesome/pro-regular-svg-icons";

import { WorkspaceDataplane } from "src/clients/flow-api";
import { Button } from "src/design-system/Button";
import { Icon } from "src/design-system/Icon";
import { ModelDropzoneController as ModelUploadController } from "src/mlNode/ModelUploadController";

type Props = {
  onFileSelect: (file: File) => void;
  isUploading: boolean;
  workspace: WorkspaceDataplane;
};

export const ModelDropzone: React.FC<Props> = ({
  onFileSelect,
  isUploading,
  workspace,
}) => {
  return (
    <ModelUploadController
      className="relative flex grow flex-col items-center justify-center rounded-xl border border-gray-200 bg-gray-50"
      disabled={isUploading}
      workspace={workspace}
      onFileSelect={onFileSelect}
    >
      <div className="flex items-center justify-center rounded-full border-2 border-indigo-200 p-1.5">
        <Icon variant="active" icon={faCloudArrowUp} size="md" />
      </div>
      <p className="mt-5 select-none font-inter-semibold-13px text-gray-800">
        Upload Model File Here
      </p>
      <p className="mt-2 max-w-[245px] select-none px-1 text-center font-inter-normal-12px text-gray-500">
        Drag an .onnx file here or upload from your computer
      </p>
      <div className="absolute bottom-0 mb-10 w-full px-10">
        <Button
          dataLoc="model-upload-button"
          isDisabled={isUploading}
          isLoading={isUploading}
          variant="primary"
          fullWidth
        >
          Upload a file
        </Button>
      </div>
    </ModelUploadController>
  );
};
